module.exports = __webpack_public_path__ + "img/width-wide@2x.8d93172.webp";